import { __extends } from "tslib";
import { makeEventParametersResolver } from '../resolvers/eventParameters';
import { StatistBrowserClient } from './statist-browser-client';
import { clientInitOptionsResolver } from '../resolvers/clientInitOptions';
var StatistEventClient = /** @class */ (function (_super) {
    __extends(StatistEventClient, _super);
    function StatistEventClient(options) {
        var resolvedOptions = clientInitOptionsResolver(options);
        return _super.call(this, resolvedOptions.clientParameters, StatistBrowserClient.createTransport(resolvedOptions), resolvedOptions.eventParameters || makeEventParametersResolver(), resolvedOptions.sessionTimeout) || this;
    }
    StatistEventClient.prototype.send = function (project, event, parameters, clientParameters) {
        return _super.prototype.send.call(this, project, event, parameters || {}, clientParameters);
    };
    return StatistEventClient;
}(StatistBrowserClient));
export { StatistEventClient };
//# sourceMappingURL=statist-event-client.js.map